
import { Component, Vue } from 'vue-property-decorator'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import AppTab from '@/components/AppTab.vue'
import { ChildComponentMixin } from '@/mixins'

interface TabData {
    id: string
    text: string
    badge: number
    filters: string
}

@Component({
    components: {
        FontAwesomeIcon,
        AppTab,
    },
})
export default class HomeFilters extends ChildComponentMixin {
    public tabs: TabData[] = [
        { id: 'all', text: 'Todos', badge: 0, filters: '' },
        {
            id: 'building',
            text: 'Em andamento',
            badge: 0,
            filters:
                'android,ios,REQUESTED,ENQUEUED,BUILDING,WAITING_FOR_REVIEW,IN_REVIEW,WAITING_TO_SEND_TO_REVIEW,PREPARE_FOR_SUBMISSION,SENDING_TO_REVIEW',
        },
        {
            id: 'errors',
            text: 'Com problemas',
            badge: 0,
            filters:
                'android,ios,ERROR,UNKNOWN_ERROR,REJECTED,WAITING_AUTH,DELETE_DEV_CERTIFICATES,MISSING_DEVICE,WRONG_CREDENTIALS,NAME_DUPLICATED,MISSING_ITC_TEAM_ID,DD_ACCOUNT,SHARED_ACCOUNT,WARNING,MANUAL_SUBMISSION',
        },
        {
            id: 'ready',
            text: 'Publicado',
            badge: 0,
            filters: 'android,ios,READY_FOR_SALE',
        },
        { id: 'renew', text: 'Renovação', badge: 0, filters: 'EXPIRED,EXPIRING' },
    ]
    private currentTab: TabData = this.tabs[0]
    private platformChips = ['android', 'ios']
    private activePlatform: string[] = []
    private activeChips: string[] = []

    get chips() {
        const status = [
            { id: 'REQUESTED', text: 'Solicitado' },
            { id: 'ENQUEUED', text: 'Aguardando compilação' },
            { id: 'BUILDING', text: 'Compilando' },
            { id: 'ERROR', text: 'Erros' },
            { id: 'UNKNOWN_ERROR', text: 'Erros de compilação' },
            { id: 'WAITING_FOR_REVIEW', text: 'Aguardando revisão' },
            { id: 'WAITING_TO_SEND_TO_REVIEW', text: 'Aguardando para enviar para revisão' },
            { id: 'PREPARE_FOR_SUBMISSION', text: 'Aguardando processamento do aplicativo' },
            { id: 'SENDING_TO_REVIEW', text: 'Enviando aplicativo para revisão' },
            { id: 'IN_REVIEW', text: 'Em revisão' },
            { id: 'REJECTED', text: 'Rejeitado' },
            { id: 'READY_FOR_SALE', text: 'Publicado' },
            { id: 'WARNING', text: 'App com produtos bloqueados/restritos' },
            { id: 'WAITING_AUTH', text: 'Aguardando autenticação' },
            { id: 'EXPIRED', text: 'Conta expirada' },
            { id: 'EXPIRING', text: 'Conta a expirar' },
            { id: 'DELETE_DEV_CERTIFICATES', text: 'Deletar Certificados' },
            { id: 'MISSING_DEVICE', text: 'Faltando dispositivo' },
            { id: 'WRONG_CREDENTIALS', text: 'E-mail/Senha incorretos' },
            { id: 'NAME_DUPLICATED', text: 'Nome duplicado' },
            { id: 'DD_ACCOUNT', text: 'Conta ITCapital' },
            { id: 'SHARED_ACCOUNT', text: 'Conta compartilhada' },
            { id: 'MANUAL_SUBMISSION', text: 'Enviar para revisão manualmente' },
            {
                id: 'MISSING_ITC_TEAM_ID',
                text: 'MacManaus não adicionado como dev',
            },
        ].sort((a, b) => (a.text > b.text ? 1 : -1))

        status.unshift(
            { id: 'android', text: 'Android' },
            { id: 'ios', text: 'iOS' },
        )

        const currentFilter = this.currentTab.filters
        if (currentFilter === '') {
            return status
        }

        const currentFilters = currentFilter.split(',')
        return status.filter((stat) => {
            let res = false
            currentFilters.forEach((filter) => {
                res = res || stat.id === filter
            })
            return res
        })
    }

    /**
     * As mounted is called before this.$store.state.home.filters has all the info setted up,
     * we need to get brandName and brandId from query params.
     */
    public async mounted() {
        const platform = this.$route.query.platform
        const status = this.$route.query.status
        const tab = this.$route.query.tab

        if (typeof tab === 'string') {
            this.currentTab = this.tabs.find((t) => t.id === tab) ?? this.tabs[0]
        } else {
            this.currentTab = this.tabs[0]
        }

        if (typeof platform === 'string') {
            platform.split(',').forEach((p) => {
                if (p !== null) {
                    this.manageFilters(p, this.activePlatform)
                }
            })
        }

        if (typeof status === 'string') {
            status.split(',').forEach((s) => {
                if (s !== null) {
                    this.manageFilters(s, this.activeChips)
                }
            })
        }

        this.tabs[2].badge = await this.$store.dispatch(
            'home/getAppsWithErrors',
        )
    }

    public fetchApps() {
        const { brandId, brandName } = this.$store.state.home.filters
        const arrFilters =
            this.activeChips.length > 0
                ? this.activeChips
                : this.currentTab.filters.split(',')
        const tab = this.currentTab.id

        let platform = ''
        if (this.activePlatform.includes('android')) {
            platform = 'android'
        }
        if (this.activePlatform.includes('ios')) {
            platform = 'ios'
        }
        if (
            this.activePlatform.includes('android') &&
            this.activePlatform.includes('ios')
        ) {
            platform = ''
        }

        const status = arrFilters
            .filter((f) => !this.platformChips.includes(f))
            .join(',')

        this.$store.dispatch('home/filterApps', {
            brandName,
            brandId,
            platform,
            status,
            tab,
        })
    }

    public filter(tabFilter: TabData) {
        this.currentTab = tabFilter
        this.activeChips = []
        this.activePlatform = []
        this.fetchApps()
    }

    public filterChip(chipFilter: string) {
        if (this.platformChips.includes(chipFilter)) {
            this.activePlatform = this.manageFilters(
                chipFilter,
                this.activePlatform,
            )
        } else {
            this.activeChips = this.manageFilters(chipFilter, this.activeChips)
        }

        this.fetchApps()
    }

    private manageFilters(
        chipFilter: string,
        filtersArray: string[],
    ): string[] {
        if (filtersArray.includes(chipFilter)) {
            filtersArray = filtersArray.filter(
                (filter) => filter !== chipFilter,
            )
        } else {
            filtersArray.push(chipFilter)
        }

        return filtersArray
    }
}
